import axios from "axios";
export const TCMStatusApi = {
  getTCMStatusSearchData: async (
    documentId: string,
    cusip: string
  ): Promise<any> => {
    const url = `${process.env.REACT_APP_TCMSTATUS_URL}?documentId=${documentId}&cusip=${cusip}`;
    try {
      const response = await axios.get(url, {
        headers: {
          "Content-Type": "application/json",
          BusinessUnitName: "TCMOne",
          "Ocp-Apim-Subscription-Key": `${process.env.REACT_APP_OCP_APIM_SUBSCRIPTION_KEY}`,
          Authorization: `${process.env.REACT_APP_AUTHORIZATION}`,
        },
      });

      // Check if the API response contains a failure status
      if (response.data?.responseStatus === "Failure") {
        return {
          status: "Failure",
          rejectedReason: response.data.rejectedReason,
        };
      }
      return response.data;
    } catch (error: any) {
      console.error("Error during TCMStatus:", error);
      // Handle specific error response from the API
      if (error.response) {
        return {
          status: error.response.status,
          data: error.response.data,
        };
      }
    }
  },
};
